export const EXCEPTION_STATUS_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  // TOKEN_INVALID: 433,
  GENERAL: 500,
} as const
